<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
  >
    <PrescriptionSupportContent />
    <template
      v-if="showSkip"
      #actions
    >
      <BaseButton
        :text="$t('generic_skip')"
        data-qa="cancel"
        @click="handleSkip"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import { computed } from 'vue'
import useEuStore from '@eu/app/stores/useEuStore.js'
import env from '@shared/env.js'
import { isFromApp } from '@shared/helpers/isFromApp'
import useDeepLink, {
  DEEP_LINK_CONFIGS,
} from '@shared/composables/useDeepLink.js'
import ROUTE from '@eu/app/router/appModule/names'
import BaseButton from '@shared/components/BaseButton.vue'
import Tracker from '@shared/Tracker'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import PrescriptionSupportContent from '@eu/app/components/PrescriptionSupportContent.vue'
import useOnboardingProgress from '@eu/app/composables/useOnboardingProgress.js'
import useNavigation from '@eu/app/composables/useNavigation'

const euStore = useEuStore()
const { progress } = useOnboardingProgress()
const { navigateNext } = useNavigation(ROUTE.PRESCRIPTION_SUPPORT)
const { getDeepLink } = useDeepLink(DEEP_LINK_CONFIGS.activationProgress)
const showSkip = computed(
  () => euStore.startRoute !== ROUTE.PRESCRIPTION_SUPPORT,
)

const handleSkip = async () => {
  Tracker.trackButtonSelect('skip', 'signup_get_diga_prescription_support')
  if (isFromApp() && !env.features.diga) {
    window.location.redirectToDeeplink(await getDeepLink())
    return
  }
  navigateNext()
}
</script>
